import * as React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { FindingTemplate } from "./index.template";

import { FindingConsulting } from "pages/finding/consulting";
import { FindingDescription } from "pages/finding/description";
import { FindingEvidence } from "pages/finding/evidence";
import { FindingMachine } from "pages/finding/machine";
import { FindingRecords } from "pages/finding/records";
import { FindingSeverity } from "pages/finding/severity";
import { FindingTracking } from "pages/finding/tracking";
import { FindingVulnerabilities } from "pages/finding/vulnerabilities";
import { useGroupUrl } from "pages/group/hooks";

const Finding: React.FC = (): JSX.Element => {
  const { params, url } = useGroupUrl("/vulns/:findingId/*");

  const findingRegex =
    /[0-9A-Za-z]{8}-[0-9A-Za-z]{4}-4[0-9A-Za-z]{3}-[89ABab][0-9A-Za-z]{3}-[0-9A-Za-z]{12}|\d+/u;
  const { findingId } = params;

  if (findingId !== undefined && !findingRegex.test(findingId)) {
    return <Navigate to={"/home"} />;
  }

  return (
    <FindingTemplate>
      <Routes>
        <Route
          element={<FindingVulnerabilities />}
          path={`/locations/:vulnerabilityId`}
        />
        <Route element={<FindingVulnerabilities />} path={`/locations`} />
        <Route element={<FindingDescription />} path={`/description`} />
        <Route element={<FindingSeverity />} path={`/severity`} />
        <Route element={<FindingEvidence />} path={`/evidence`} />
        <Route element={<FindingMachine />} path={`/machine`} />
        <Route element={<FindingTracking />} path={`/tracking`} />
        <Route element={<FindingRecords />} path={`/records`} />
        <Route
          element={<FindingConsulting type={"consult"} />}
          path={`/consulting`}
        />
        <Route
          element={<FindingConsulting type={"observation"} />}
          path={`/observations`}
        />
        <Route
          element={<Navigate to={`${url}/locations`.replace("//", "/")} />}
          path={"*"}
        />
      </Routes>
    </FindingTemplate>
  );
};

export { Finding };
